module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.53e3e3ad.svg";